module.exports = __webpack_public_path__ + "img/font_englischescht.84937c5.svg";